export const OFFERS_SERVICE = "OffersService";
